import { churchTileRegistry } from "../../platforms/church/tiles/tileRegistry";

export const tileRegistry = {
  home: {
    id: "home",
    system: true,
  },

  store: {
    id: "store",
    noUninstall: true,
  },

  ...churchTileRegistry,
};
